import { useState, useEffect } from "react";
import { Grid, Box } from '@mui/material';
import { TextField } from '@mui/material';
import MainCard from './MainCard';
import { gridSpacing } from '../../store/constant';
import axios from "../../components/axios";
import { useNavigate, useParams } from 'react-router-dom';


const ModifyIPForm = () => {
    const navigate = useNavigate();
    const { uuid } = useParams();

    const styleButton = {
        marginTop: "40px",
        backgroundColor: "#406599",
        color: "#fff",
        border: 0,
        borderRadius: "5px",
        boxSizing: "border-box",
        width: "120px",
        padding: "15px",
        fontSize: "18px",
        fontFamily: '"Roboto", "sans-serif"',
      };

    const [agent, setAgent] = useState("");
    function handleAgent(e) {
        setAgent(e.target.value);
    }

    const [ip, setIP] = useState("");
    function handleIP(e) {
        setIP(e.target.value);
    }

    useEffect(() => {
      const getAgentInfo = async () => {
        try {
          var input_data = JSON.stringify({ id: parseInt(uuid) });
          const response = await axios.post("/peloton/v1/automation/swallow-one-setting", input_data, { withCredentials: true});
          if (response.data.message === "success"){
            setAgent(response.data.data.agent);
            setIP(response.data.data.ip);

          }
        } catch (error) {
            if (error.response.status !== null){
                if (error.response.status === 401){
                    alert(error.response.data.message);
                    navigate("/");
                }else{
                    console.log('error.response.status: ', error.response.status)
                    console.log('error.response.message: ', error.response.data.message)
                }
            }else{
                console.log(error);
            }
        }
    };
    getAgentInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ uuid ]);

    const handleEditAgent = async () => {
        var input_data = JSON.stringify({ uuid: parseInt(uuid), agent: agent, ip: ip });

        axios.post("/peloton/v1/automation/swallow-update-setting",input_data,{withCredentials: true})
        .then(response => {
            if (response.data.message === "success") {
              navigate("/swallow-settings");
            }else{
                alert(response.data.message);
            }
        }).catch(function(err){
          if (!err.response){
            alert(err);
          }else{
            if (err.response.status === 401){
              alert(err.response.data.message);
              navigate("/");
            }else{
                console.log('error.response.status: ', err.response.status)
                console.log('error.response.status: ', err.response.data.message)
                alert(err.response.data.message)
            }
          }
        })
    }

    return (
    <MainCard title="Modify Swallow IP Setting">
        <Box sx={{ maxWidth: '100%'}}>
        <Grid container spacing={gridSpacing} justifyContent="center" rowSpacing={gridSpacing} columnSpacing={gridSpacing}>
        <Grid item xs={4}>
          <TextField
              required
              fullWidth
              id="agent"
              label="Agent"
              value={agent}
              onChange={handleAgent}
              variant="filled"
          />
          </Grid>
          <Grid item xs={4}>
          <TextField
              required
              fullWidth
              id="ip"
              label="IP Address"
              value={ip}
              onChange={handleIP}
              variant="filled"
          />
          </Grid>

          </Grid>
          <Grid container spacing={gridSpacing} justifyContent="flex-end">
          <Grid item>
          <button style={styleButton} onClick={handleEditAgent}>Send</button>
          </Grid>
          </Grid>
          </Box>
      </MainCard>
    );
};

export default ModifyIPForm;
